module.exports = __webpack_public_path__ + "static/media/GF-jwhBaAAESzuT.0bec33ea.webp";